import { SetOverrideUseOriginalDestinationAddressActionStep } from "@redotech/redo-model/advanced-flow/oms/actions";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { memo } from "react";
import { PartialWithRequiredType } from ".";

export const OverrideUseOriginalDestinationAddressToggle = memo(
  function OverrideUseOriginalDestinationAddressToggle({
    step,
    setStep,
  }: {
    step: PartialWithRequiredType<SetOverrideUseOriginalDestinationAddressActionStep>;
    setStep: (
      step: PartialWithRequiredType<SetOverrideUseOriginalDestinationAddressActionStep>,
    ) => void;
  }) {
    return (
      <RedoToggle
        label="Use original, unverified destination address, even if the auto clean addresses setting is enabled"
        setValue={(value) =>
          setStep({ ...step, overrideUseOriginalDestinationAddress: value })
        }
        size="xs"
        value={step.overrideUseOriginalDestinationAddress ?? false}
      />
    );
  },
);
